import React from 'react';
import * as FiIcons from 'react-icons/fi';
import ConnectionStatusBadge from './ConnectionStatusBadge';
import { formatRelativeTime } from '../../lib/formatters/time';

const CHANNEL_ICONS = {
  telegram: FiIcons.FiSend,
  whatsapp: FiIcons.FiMessageCircle,
  email: FiIcons.FiMail,
  sms: FiIcons.FiSmartphone
};

function ChannelCard({ channel, onToggle, onTest }) {
  const Icon = CHANNEL_ICONS[channel.type] ?? FiIcons.FiRadio;
  const enabled = channel.enabled ?? true;
  const lastEvent = formatRelativeTime(channel.lastEventAt);

  return (
    <article className={`channel-card ${enabled ? '' : 'channel-card--disabled'}`}>
      <header className="channel-card__head">
        <span className="channel-card__icon"><Icon /></span>
        <div className="channel-card__title">
          <h3>{channel.name}</h3>
          <span>{channel.handle}</span>
        </div>
        <ConnectionStatusBadge status={channel.status} />
      </header>

      <p className="channel-card__desc">{channel.description}</p>

      <dl className="channel-card__stats">
        {/* Live rows carry no traffic counters yet (1789900004 fields, §3) —
            absent stats render as em-dashes, never fabricated numbers. */}
        <div>
          <dt>Today</dt>
          <dd>{channel.messagesToday != null ? `${channel.messagesToday} msgs` : '—'}</dd>
        </div>
        <div>
          <dt>Delivery</dt>
          <dd>{channel.deliveryRate != null ? `${Math.round(channel.deliveryRate * 1000) / 10}%` : '—'}</dd>
        </div>
        <div>
          <dt>Last event</dt>
          <dd>{channel.lastEventAt ? lastEvent : '—'}</dd>
        </div>
      </dl>

      <footer className="channel-card__actions">
        <button
          className={enabled ? 'ghost-button' : 'primary-button'}
          onClick={() => onToggle(channel.id)}
          type="button"
        >
          {enabled ? 'Disable' : 'Enable'}
        </button>
        <button
          className="ghost-button"
          disabled={channel.status === 'offline'}
          onClick={() => onTest(channel)}
          type="button"
        >
          <FiIcons.FiSend /> Test
        </button>
      </footer>
    </article>
  );
}

export default ChannelCard;
